module.exports = __webpack_public_path__ + "img/twitter.c44d3c8e.svg";